var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"a-d-marker fs-12"},[_vm._t("default",function(){return [_vm._v("Advertisement")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }